import React, { createContext, useContext, useState, useEffect } from 'react';

const CART_KEY = 'nrk_cart_v2';
const round2 = (n) => Math.round(n * 100) / 100;
const round3 = (n) => Math.round(n * 1000) / 1000;

function fixImageUrl(url) {
  if (!url || typeof url !== 'string') return null;
  let id = null;
  let m = url.match(/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/);
  if (m) id = m[1];
  if (!id) { m = url.match(/drive\.google\.com\/open\?id=([a-zA-Z0-9_-]+)/); if (m) id = m[1]; }
  if (!id) { m = url.match(/[?&]id=([a-zA-Z0-9_-]+)/); if (m) id = m[1]; }
  return id ? 'https://drive.google.com/thumbnail?id=' + id + '&sz=w400' : url;
}

const CartContext = createContext(null);

function notifyItemAdded(product) {
  try {
    if (typeof window !== 'undefined' && window.dispatchEvent) {
      window.dispatchEvent(new CustomEvent('nrk:item-added', {
        detail: { name: product?.name_en || 'Item' },
      }));
    }
  } catch {}
}

export function CartProvider({ children }) {
  const [cart, setCart] = useState(() => {
    try { const v = localStorage.getItem(CART_KEY); const p = v ? JSON.parse(v) : null; return Array.isArray(p) ? p : []; }
    catch { return []; }
  });

  useEffect(() => {
    try { localStorage.setItem(CART_KEY, JSON.stringify(cart)); } catch {}
  }, [cart]);

  const addItem = (product, qty) => setCart((prev) => {
    const existing = prev.find((i) => i.product_id === product.id);
    const price = parseFloat(product.sell_price != null ? product.sell_price : product.price_per_kg) || 0;
    if (existing) {
      const newQty = round3(existing.quantity_kg + qty);
      if (newQty <= 0) return prev.filter((i) => i.product_id !== product.id);
      notifyItemAdded(product);
      return prev.map((i) => i.product_id === product.id ? { ...i, quantity_kg: newQty, subtotal: round2(newQty * i.price_per_kg) } : i);
    }
    if (qty <= 0) return prev;
    notifyItemAdded(product);
    return [...prev, { product_id: product.id, product_name: product.name_en, product_name_te: product.name_te, price_per_kg: price, sell_price: price, unit: product.unit || 'kg', quantity_kg: qty, subtotal: round2(qty * price), image_url: fixImageUrl(product.image_url) }];
  });

  const removeItem = (productId) => setCart((prev) => prev.filter((i) => i.product_id !== productId));
  const updateQty = (productId, qty) => {
    if (qty <= 0) return removeItem(productId);
    setCart((prev) => prev.map((i) => i.product_id === productId ? { ...i, quantity_kg: round3(qty), subtotal: round2(round3(qty) * i.price_per_kg) } : i));
  };
  const clearCart = () => setCart([]);
  const itemCount = cart.reduce((s, i) => s + (i.quantity_kg || 0), 0);
  const total = round2(cart.reduce((s, i) => s + (i.subtotal || 0), 0));

  return React.createElement(CartContext.Provider, { value: { cart, addItem, removeItem, updateQty, clearCart, itemCount, total } }, children);
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCart must be inside CartProvider');
  return ctx;
}
